import { isEmpty } from '@helpers/utils/utils.js';
import { ENV_ACTIVE } from '../env.js';

export const urlUtils = {
  buildFullPath: (root, data, removeIfEmpty = true) => {
    if (!data) return root;

    for (const dataKey in data) {
      if (typeof data[dataKey] !== 'boolean' && isEmpty(data[dataKey])) {
        if (removeIfEmpty) {
          delete data[dataKey];
        } else {
          data[dataKey] = '';
        }
      }
    }
    const searchParams = new URLSearchParams(data);
    return `${root}?${searchParams.toString()}`;
  },
};

export const convertToIHS = () => {
  let origin;
  let localPath;

  if (location.pathname.includes('/index.html')) {
    localPath = `${location.pathname.split('/index.html')[0]}/`;
  } else {
    localPath = location.pathname;
  }

  if (location.origin.includes('localhost')) {
    origin = new URL(`http://localhost:${window.location.port}/assets`);
    // K8s interrnal  & dev || sit || at
  } else if (location.origin.includes('sunlifecorp.com')) {
    if (ENV_ACTIVE === 'dev' || ENV_ACTIVE === 'sit' || ENV_ACTIVE === 'sit2') {
      origin = new URL(
        `https://apps-vn-st.sunlifecorp.com/vnSunportal/resources`,
      );
    } else {
      origin = new URL(
        `https://online-vn-at.sunlifecorp.com/vnSunportal/resources`,
      );
    }
  }
  // uat external
  else if (location.origin.includes('sandbox')) {
    origin = new URL(`https://sandbox.sunlife.com.vn/vnSunportal/resources`);
  }
  // pr external & interianl
  else {
    // K8s
    if (
      location.origin.includes('vn-aws-ap1-apps-prd') ||
      location.origin.includes('sunlife.com.vn')
    ) {
      origin = new URL(`https://online.sunlife.com.vn/vnSunPortal/resources`);
    }
  }

  return origin;
};
